<template>
  <div style="height: 100%">
    <material-card
      color="#68c6b3"
      title="Where you've chosen to impact"
      offset="0"
      style="height: 100%"
    >
      <v-layout justify-center wrap v-if="chosenGoodCause != undefined">
        <v-flex xs12>
          <p style="font-weight: bold" class="my-0">
            Your chosen Good Cause / Area of Impact
          </p>
          <p>
            This is the Good Cause / Area of Impact that your contribution
            benefits. To change please email
            <a href="mailTo:admin@upstreamnz.co.nz" target="_blank"
              >admin@upstreamnz.co.nz</a
            >
          </p>
        </v-flex>
        <v-flex xs12>
          <v-img :src="chosenGoodCause.imageUrl"></v-img>
        </v-flex>

        <v-flex xs12 style="text-align: left">
          <p style="color: #325181; font-size: 15pt !important">
            Most recent impact story
          </p>
        </v-flex>
        <v-flex xs12>
          <p>
            {{ chosenGoodCause.goodCauseRecentImpactStory }}
          </p>
        </v-flex>
      </v-layout>
    </material-card>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import moment from "moment";

  export default {
    components: {},
    data: () => ({}),
    computed: {
      ...mapGetters({
        user: "user",
        userData: "user/userData",
        chosenGoodCause: "stats/impactBuyerChosenGoodCause",
      }),
    },
    watch: {},
    mounted() {
      this.$store.dispatch(
        "stats/loadImpactBuyerChosenGoodCause",
        this.userData.impactBusiness_id
      );
    },
    methods: {},
    filters: {
      moment: function (date) {
        return moment.utc(date).local().format("MMM Do YYYY, h:mm a");
      },
    },
  };
</script>

<style lang="css">
  #statsModule h4.title.font-weight-light.mb-2 {
    font-weight: bold !important;
  }
</style>